import ISaveModel from "../../../../../shared/src/ranj/equalture/savegame/ISaveModel";
import GameModel from "./GameModel";
import Config from "../../../../../shared/src/ranj/app/config/Config";

export default class SaveModel extends ISaveModel {

    /**
     * 
     * @param {GameModel} gameModel 
     * @param {Config} config 
     */
    constructor(gameModel, config) {
        super();
        this._gameModel = gameModel;
        this._config = config;

        this._saveGame = null;
    }

    setSaveGame(obj) {
        if (obj != null) {
            const currentVersion = this._config.getValue(Config.VERSION);
            if (currentVersion == obj.version) {
                this._saveGame = obj;
                console.log("SaveModel.setSaveGame", obj);
            } else {
                console.warn(`Savegame version (${obj.version}) does not correspond to current version (${currentVersion}). Ignoring savegame.`);
            }
        } else {
            console.log("SaveModel.setSaveGame, no savegame");
        }
    }

    /**
     * @returns {Object} Generic object containing save state.
     */
    getSaveGame() {
        return this._saveGame;
    }

    createSaveGame() {
        return {
            version: this._config.getValue(Config.VERSION),
            elapsed: Math.round(this._gameModel.elapsedTime),
            index: this._gameModel.puzzleIndex,
            score: this._gameModel.score,
            mistakeCount: this._gameModel.mistakeCount,
            puzzle: this._gameModel.puzzle.toObject()
        };
    }
};
